export default __webpack_public_path__ + "static/Paraphotistus-c4200916359e717fb48fd3baa751fb39.png";